export const mapTypesButtons = [
  {
    type: 'location',
    label: 'Location',
  },
  {
    type: 'event',
    label: 'Incidents',
  },
  {
    type: 'datachain',
    label: 'Network',
  },
  {
    type: 'risk',
    label: 'Risk',
  },
];
